import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  makeStyles,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import { gpColors } from "../../../constants/colors";
import SideDrawer from "../Drawer";
import { getCookie } from "../../../Functions";
import CryptoAES from "crypto-js/aes";
import CryptoENC from "crypto-js/enc-utf8";
import AddProductValMOdal from "../AddProductValMOdal";
import Cookies from "js-cookie";
import api from "../../Interceptors/axiosInstance";
const useStyles = makeStyles((theme) => ({
  roots: {
    display: "flex",
    height: "auto",
  },
  content: {
    backgroundColor: "#EAE4E8",
    flexGrow: 1,
    paddingTop: "84px",
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    height: "10%",
    width: "100%",
  },
  title: {
    fontSize: "20px",
    fontWeight: 600,
    paddingBottom: 20,
  },
  root: {
    padding: "30px",
    minHeight: "280px",
    marginTop: "20px",
  },
  fieldBox: {
    width: "48%",
    margin: 5,
    [theme.breakpoints.only("xs")]: {
      width: "100%",
    },
    [theme.breakpoints.only("sm")]: {
      width: "100%",
    },
  },
  textFieldStyle: {
    width: "100%",
    height: "40px",
  },
  submitButton: {
    textTransform: "none",
    backgroundColor: gpColors.logoBrown,
    color: "#fff",
    marginBottom: "12px",
    width: "20%",
    "&.MuiButtonBase-root": {
      "&:hover": { backgroundColor: gpColors.logoBrown },
    },
    [theme.breakpoints.down("sm")]: {
      width: "70%",
    },
    [theme.breakpoints.only("md")]: {
      width: "30%",
    },
  },
}));

const AddUsers = () => {
  const classes = useStyles();
  const [userData, setUserData] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);

  const [addUserData, setAddUserData] = useState({
    firstName: "",
    lastName: "",
    username: "",
    role: "",
    password: "",
    conformPassword: "",
    accessId: "",
  });

  const [alert, setAlert] = useState({
    alertStatus: false,
    alertMessage: "",
    alertColor: "",
  });

  const [validationModal, setValidationModal] = useState(false);
  function openValidationModal() {
    setValidationModal(true);
  }
  function closeValidationModal() {
    setValidationModal(false);
  }

  // Alert box close
  const handleAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({
      ...alert,
      alertStatus: false,
      alertColor: "",
      alertMessage: "",
    });
  };

  //Getting cookies
  // const getLoginInfoData = () => {
  //     const getValue = getCookie("guardPlus_user");
  //     if (getValue !== null) {
  //         const decryptedValue = CryptoAES.decrypt(getValue, "secretKey");
  //         const userVal = JSON.parse(decryptedValue.toString(CryptoENC));
  //         setUserData(userVal);
  //     }
  // };

  // const sessionUsername = Cookies.get("userName");
      const sessionUsername = sessionStorage.getItem("userName");

  const getLoginInfoData = () => {
    setUserData({ username: sessionUsername });
  };
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    getLoginInfoData();
  }, []);

  const handleUserData = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    setAddUserData((prevData) => ({
      ...prevData,
      [name]: value, // Dynamically update the property with the value
    }));
  };

  const saveUserData = async () => {
    console.log("save user");
    const anyFieldEmpty = Object.values(addUserData).some(
      (value) => value === ""
    );

    if (anyFieldEmpty) {
      console.log("true: ", anyFieldEmpty);
      openValidationModal();
      return;
    }
    if (addUserData.password !== addUserData.conformPassword) {
      setAlert({
        ...alert,
        alertStatus: true,
        alertColor: "red",
        alertMessage: "Password and Confirm Password do not match.",
      });
      return;
    }
    setBtnLoader(true);
    try {
      // const resp = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/addUser`,
      //     {
      //         method: "POST",
      //         body: JSON.stringify({
      //             firstName: addUserData.firstName,
      //             lastName: addUserData.lastName,
      //             emailId: addUserData.username,
      //             password: addUserData.password,
      //             role: addUserData.role,
      //             accessId: addUserData.accessId,
      //         }),
      //         headers: {
      //             // "ngrok-skip-browser-warning": "true",
      //             Authorization: `Token ${userData.loginInfo.data.jwt}`,
      //             "Content-Type": "application/json",
      //         },
      //     })
      const resp = await api.post("/addUser", {
        firstName: addUserData.firstName,
        lastName: addUserData.lastName,
        emailId: addUserData.username,
        password: addUserData.password,
        role: addUserData.role,
        accessId: addUserData.accessId,
      });

      console.log("Response:", resp.data);

      const data = await resp.data;
      setBtnLoader(false);
      if (data.result === "Success") {
        setAddUserData({
          firstName: "",
          lastName: "",
          username: "",
          role: "",
          password: "",
          conformPassword: "",
          accessId: "",
        });
        setAlert({
          ...alert,
          alertStatus: true,
          alertColor: "green",
          alertMessage: "New user has been added successfully!!",
        });
      } else if (data.result === "Username already exist") {
        setAlert({
          ...alert,
          alertStatus: true,
          alertColor: "red",
          alertMessage: "User already exists, please try a different one.",
        });
      } else {
        setAlert({
          ...alert,
          alertStatus: true,
          alertColor: "red",
          alertMessage: "Something went wrong please try again.",
        });
      }
    } catch (e) {
      console.error(e);
      setBtnLoader(false);
      setAlert({
        ...alert,
        alertStatus: true,
        alertColor: "red",
        alertMessage: "Something went wrong please try after some time.",
      });
    }
  };

  return (
    <Box className={classes.roots}>
      <SideDrawer tabName="addUsers" userData={userData} />
      <main className={classes.content}>
        <Typography className={classes.title}>Add User</Typography>
        <Divider />
        <Card className={classes.root}>
          <CardContent>
            <>
              <Box display="flex" flexWrap="wrap">
                <Box className={classes.fieldBox}>
                  <Typography>
                    First Name<label style={{ color: "red" }}>*</label>
                  </Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    className={classes.textFieldStyle}
                    name="firstName"
                    value={addUserData.firstName}
                    onChange={(e) => handleUserData(e)}
                  />
                </Box>
                <Box className={classes.fieldBox}>
                  <Typography>
                    Last Name<label style={{ color: "red" }}>*</label>
                  </Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    className={classes.textFieldStyle}
                    name="lastName"
                    value={addUserData.lastName}
                    onChange={(e) => handleUserData(e)}
                  />
                </Box>
                <Box className={classes.fieldBox}>
                  <Typography>
                    Username<label style={{ color: "red" }}>*</label>
                  </Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    className={classes.textFieldStyle}
                    name="username"
                    value={addUserData.username}
                    onChange={(e) => handleUserData(e)}
                  />
                </Box>
                <Box className={classes.fieldBox}>
                  <Typography>
                    Role<label style={{ color: "red" }}>*</label>
                  </Typography>
                  <Select
                    className={classes.textFieldStyle}
                    variant="outlined"
                    name="role"
                    value={addUserData.role}
                    onChange={(e) => handleUserData(e)}
                    input={<OutlinedInput />}
                  >
                    <MenuItem value="1">Admin</MenuItem>
                    <MenuItem value="2">User</MenuItem>
                  </Select>
                </Box>
                <Box className={classes.fieldBox}>
                  <Typography>
                    Password<label style={{ color: "red" }}>*</label>
                  </Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    type="password"
                    className={classes.textFieldStyle}
                    name="password"
                    value={addUserData.password}
                    onChange={(e) => handleUserData(e)}
                  />
                </Box>
                <Box className={classes.fieldBox}>
                  <Typography>
                    Confirm Password<label style={{ color: "red" }}>*</label>
                  </Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    type="password"
                    className={classes.textFieldStyle}
                    name="conformPassword"
                    value={addUserData.conformPassword}
                    onChange={(e) => handleUserData(e)}
                  />
                </Box>
                <Box className={classes.fieldBox}>
                  <Typography>
                    Access<label style={{ color: "red" }}>*</label>
                  </Typography>
                  <Select
                    className={classes.textFieldStyle}
                    variant="outlined"
                    name="accessId"
                    value={addUserData.accessId}
                    onChange={(e) => handleUserData(e)}
                    input={<OutlinedInput />}
                  >
                    <MenuItem value="1">Inward Scan</MenuItem>
                    <MenuItem value="2">Outward Scan</MenuItem>
                    <MenuItem value="3">Both</MenuItem>
                  </Select>
                </Box>
              </Box>
              <Box display="flex" justifyContent="center" marginTop={2}>
                <Button className={classes.submitButton} onClick={saveUserData}>
                  {btnLoader ? <CircularProgress size={25} /> : "SUBMIT"}
                </Button>
              </Box>
            </>
          </CardContent>
        </Card>
      </main>
      {/* Validation modal and alert box for API results component */}
      <AddProductValMOdal
        validationModal={validationModal}
        closeValidationModal={closeValidationModal}
        handleAlertClose={handleAlertClose}
        alert={alert}
      />
    </Box>
  );
};
export default AddUsers;
